export default "__VITE_ASSET__DzaM9$OY__"